<script>
import Layout from "../../layouts/main";
import Style from "@/views/layouts/style";
import PageHeader from "@/components/Page-header";
import appConfig from "@/../app.config";
import inventory_miAPI from "@/services/standards/inventory_mi/inventory_miAPI";
import maintenanceAPI from "@/services/standards/inventory_mi/maintenanceAPI";
import CompanyItemsAPI from "@/services/items/companies_itemsAPI"
import Pagination from "@/components/standard/inventory_mi/inventoryPagination";
import Swal from "sweetalert2";
import { sendNotification } from "@/utils/helpers/notification"
import CheckModal from "@/components/CheckModal"
import { dateFormat } from "@/utils/helpers/format";
import ItemAPI from "@/services/items/itemsAPI";
import newScoresAPI from "../../../services/newScores/newScoresAPI";

/**
 * Form elements component
 */
export default {
  page: {
    title: "4.2.5 Mantenimiento periódico de instalaciones, equipos, máquinas, herramientas",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    Style,
    PageHeader,
    CheckModal,
    Pagination,
  },
  data() {

    return {
      title: "4.2.5 Mantenimiento periódico de instalaciones, equipos, máquinas, herramientas",
      items: [

        {
          text: "Estandares",
          href: "/forms/estandares",
        },
        {
          text: "Mantenimiento periódico de instalaciones, equipos, máquinas, herramientas",
          active: true,
        },
      ],

      lista: [],
      loading: true,
      item: null,
      itemStatus: "No cumplido",
      deleteCount: 0,
      itemData: null,
      inventory: {
        code: null,
        name: null,
        description: null,
        brand: null,
        model: null,
        maintenance_frequency_months: null,
        status: 1,
        companies_id: this.$store.getters["company/getCompany"].id || null,
      },
      // Catálogo de periodicidades (config/maintenance.php) y ventana de preaviso del semáforo.
      frequencies: {},
      alertDays: 30,
      downloading: false,
      submitted: false,
      companyID: this.$store.getters["company/getCompany"].id || null,
      classificationID: this.$store.getters["company/getCompany"].company_classification_id || null,
      user: this.$store.state.auth || null,
    };
  },
  methods: {
    getItemData() {
      ItemAPI.getItems(49)
        .then((response) => {
          this.itemData = response;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    allowAccess() {
      try {
        const item = this.itemData;

        if (item) {
          const classificationID =
            this.$store.getters["company/getCompany"].company_classification_id || null;

          if (classificationID === 1 && item.obligatory_UPA === 1) {
            return true;
          } else if (classificationID === 2 && item.obligatory_groupI === 1) {
            return true;
          } else if (classificationID === 3 && item.obligatory_groupII === 1) {
            return true;
          } else if (classificationID === 4 && item.obligatory_groupIII === 1) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } catch (error) {
        console.log(error);
        return false;
      }
    },

    fetch() {
      this.$refs.paginator.query();
    },

    dateConvert(date) {
      return dateFormat(date);
    },

    getItems() {
      CompanyItemsAPI.getStatus(this.companyID, 49)
        .then(response => {
          this.item = response || null
          this.itemStatus = response.status !== undefined ? response.status : this.itemStatus;
        })
        .catch(error => {
          console.log(error)
        })
    },

    changeItemStatus(itemStatus) {
      const itemChange = {
        companies_id: this.companyID,
        item_id: 49,
        status: itemStatus,
      };
      newScoresAPI.calculateScores(itemChange)
        .then((response) => {
          Swal.fire({
            title: "¡Éxito!",
            text: "¡Se ha cambiado el estado del ítem con éxito!",
            icon: "success",
            style: "success",
            confirmButtonClass: "btn btn-confirm mt-2",
          });
          setTimeout(() => window.location.reload(), 2000)
        })
        .catch((error) => {
          Swal.fire({
            title: "¡ERROR!",
            text: "¡No se ha actualizado el estado del ítem!",
            icon: "error",
            style: "error",
            confirmButtonClass: "btn btn-confirm mt-2",
          });

          setTimeout(() => window.location.reload(), 2000)
          console.log(error);
        });
    },

    /**
         * This method is used to send notification to SST user and SST company.
         * The sendNotification method import is required.
         * @param {Number} messageID - The message ID that will be associated to notification.
         * @param {Number} itemID - The item ID that will be associated to notification.
         * @param {Boolean} user - The user that will e associated to notification.
         * @return {Boolean} True if the notification is sent, false if not.
         */
    sendNotification(messageID, itemID, user) {
      const company = this.$store.getters["company/getCompany"];
      return sendNotification(company.id, user ? company.id_diseno_sso : null, messageID, itemID);
    },

    /**
    * This method is used to knows if the user has the permission indicated
    * @param {String} name The name of the permission
    * @param {Array} roles the roles that permitted to access the action 
    * @returns {Boolean} true if the user has the permission indicated or false if no
    */
    getRole(name, roles) {

      // Get the user role
      let role = this.$store.state.auth.info.role ? this.$store.state.auth.info.role : null

      // If the user is logged
      if (role) {

        // If the roles array is not empty
        if (roles) {

          // Know if the role indicated is in the roles array
          role = roles.includes(role) ? true : false

        } // Close if the roles arrays is not empty

        // If the roles arrays is empty
        else {

          // Know if the user role is in the roles indicated
          role = role === 1 || role === 2 || role === 3 || role === 4 || role === 5 || role === 6 || role === 7 || role === 8

        } // Close if the roles arrays is empty

        // Get the user permissions
        const permissions = this.$store.state.auth.info.permissions

        // Know if the user has the permission indicated
        const enabled = permissions.find(permission => permission.name === name)

        // If the user has the permission indicated and the user role is in the roles indicated
        return enabled && role ? true : false

      } // Close if the user is logged

      // If the user is not logged
      else {
        return false
      } // Close else the user is not logged
    },

    /**
   * This method is used to redirect to the page indicated
   * @param {String} page The page to redirect
   */
    goPage(page) {
      window.location.href = page
    },

    /**
     * Catálogo de periodicidades y ventana de preaviso del backend (config/maintenance.php),
     * para que el formulario, el semáforo y el reporte usen los mismos valores.
     * @returns {Promise} resuelve cuando el catálogo ya está en data.
     */
    getCatalogs() {
      return inventory_miAPI.catalogs()
        .then((res) => {
          if (!res) return;
          this.frequencies = res.frequencies || {};
          this.alertDays = res.alert_days || 30;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    /**
     * Descarga el reporte de cumplimiento de mantenimientos en Excel (ítem 4.2.5): un activo
     * por fila con su periodicidad, último mantenimiento, próximo vencimiento y semáforo.
     */
    downloadComplianceReport() {
      this.downloading = true;
      inventory_miAPI.getExcel(this.companyID, this.alertDays, false)
        .then((link) => {
          window.location.href = link;
          this.downloading = false;
        })
        .catch((error) => {
          this.downloading = false;
          Swal.fire({
            title: "¡ERROR!",
            text: "No se pudo generar el reporte de cumplimiento.",
            icon: "error",
            confirmButtonClass: "btn btn-confirm mt-2",
          });
          console.log(error);
        });
    },

    /** Texto de la columna "Próximo mantenimiento" del listado. */
    nextDueLabel(dato) {
      if (!dato.next_due) return "No calculable";
      const n = Math.abs(dato.days);
      const suffix = dato.days < 0
        ? ` (${n} día${n === 1 ? "" : "s"} de atraso)`
        : (dato.days === 0 ? " (vence hoy)" : ` (en ${n} día${n === 1 ? "" : "s"})`);
      return this.dateConvert(dato.next_due) + suffix;
    },

    getList() {
      inventory_miAPI.getAllinventory_miPage(this.$store.getters["company/getCompany"].id || null)
        .then((response) => {
          this.lista = response.Inventory_mi.data || [];
          if (Array.isArray(this.lista)) {
            this.deleteCount = this.lista.length;
          } else {
            this.deleteCount = 0;
          }
          this.loading = false
        })
        .catch((error) => {
          console.log(error);
        });
    },

    /**
     * Alerta de mantenimientos próximos a vencer (ítem 4.2.5). Al abrir la vista consulta el
     * endpoint que calcula el PRÓXIMO mantenimiento de cada activo (último mantenimiento
     * registrado + periodicidad del activo) y lista los vencidos y los próximos a vencer.
     * Los activos sin periodicidad definida no son calculables: se avisan aparte para que el
     * cliente complete ese dato, sin el cual el semáforo del reporte queda en gris.
     */
    checkMaintenanceAlerts() {
      maintenanceAPI.alerts(this.companyID, this.alertDays)
        .then((res) => {
          if (!res) return;
          const pendientes = (res.sin_periodicidad || []).length;
          if (!res.total && !pendientes) return;
          const row = (it, overdue) => {
            const fecha = this.dateConvert(it.next_due);
            const n = Math.abs(it.days);
            const when = overdue
              ? `<span style="color:#f1556c;font-weight:600;">vencido hace ${n} día${n === 1 ? '' : 's'}</span>`
              : (it.days === 0
                ? `<span style="color:#f7b84b;font-weight:600;">vence hoy</span>`
                : `<span style="color:#f7b84b;font-weight:600;">vence en ${n} día${n === 1 ? '' : 's'}</span>`);
            return `<tr>
              <td style="text-align:left;padding:3px 8px;">${it.code || '—'}</td>
              <td style="text-align:left;padding:3px 8px;">${it.name || '—'}</td>
              <td style="padding:3px 8px;white-space:nowrap;">${it.frequency || '—'}</td>
              <td style="padding:3px 8px;white-space:nowrap;">${fecha}</td>
              <td style="padding:3px 8px;white-space:nowrap;">${when}</td>
            </tr>`;
          };
          const table = (rows) => `<table style="width:100%;font-size:13px;border-collapse:collapse;">
            <tr style="border-bottom:1px solid #eee;color:#888;font-size:11px;text-transform:uppercase;">
              <td style="text-align:left;padding:3px 8px;">Código</td>
              <td style="text-align:left;padding:3px 8px;">Equipo</td>
              <td style="padding:3px 8px;">Periodicidad</td>
              <td style="padding:3px 8px;">Próximo mtto.</td>
              <td style="padding:3px 8px;">Estado</td>
            </tr>${rows}</table>`;
          let html = '<div style="max-height:52vh;overflow:auto;text-align:left;">';
          if (res.vencidos.length) {
            html += `<h6 style="color:#f1556c;margin:6px 0;">Vencidos (${res.vencidos.length})</h6>`;
            html += table(res.vencidos.map((it) => row(it, true)).join(''));
          }
          if (res.por_vencer.length) {
            html += `<h6 style="color:#f7b84b;margin:12px 0 6px;">Próximos a vencer — ${res.days} días (${res.por_vencer.length})</h6>`;
            html += table(res.por_vencer.map((it) => row(it, false)).join(''));
          }
          if (pendientes) {
            const lista = res.sin_periodicidad
              .map((it) => `<li>${it.code || '—'} — ${it.name || '—'}</li>`)
              .join('');
            html += `<h6 style="color:#6c757d;margin:12px 0 6px;">Sin periodicidad definida (${pendientes})</h6>
              <p style="font-size:12px;color:#6c757d;margin:0 0 4px;">Estos activos no entran al semáforo
              de cumplimiento hasta que se les defina la periodicidad de mantenimiento.</p>
              <ul style="font-size:13px;padding-left:20px;margin:0;">${lista}</ul>`;
          }
          html += '</div>';
          Swal.fire({
            title: res.total ? 'Mantenimientos por vencer' : 'Periodicidad de mantenimiento pendiente',
            icon: 'warning',
            html,
            width: 720,
            confirmButtonText: 'Entendido',
            confirmButtonClass: 'btn btn-confirm mt-2',
          });
        })
        .catch((error) => {
          console.log(error);
        });
    },

    save() {
      this.submitted = true
      this.loading = true
      inventory_miAPI.save(this.inventory)
        .then((response) => {
          const itemChange = {
            companies_id: this.companyID,
            item_id: 49,
            status: 'Pendiente',
          };
          newScoresAPI.calculateScores(itemChange)
            .then((response) => {
              this.loading = false
              setTimeout(() => {
                Swal.fire({
                  title: "¡Éxito!",
                  text: "¡Se ha registrado con éxito!",
                  type: "success",
                  icon: "success",
                  confirmButtonClass: "btn btn-confirm mt-2",
                });
                window.location.reload()
              }, 2000)
            })
            .catch((error) => {
              this.loading = false
              setTimeout(() => {
                Swal.fire({
                  title: "Error",
                  text: "¡No se ha podido registrar!",
                  icon: "error",
                  type: "error",
                  confirmButtonClass: "btn btn-confirm mt-2",
                });
                window.location.reload();
              }, 1000);
              console.log(error);
            });
        })
        .catch((error) => {
          console.log(error);
          this.loading = false
        });
    },

    deleteR(id) {
      inventory_miAPI
        .delete(id)
        .then((response) => {
          if (this.deleteCount > 0) {
            this.deleteCount -= 1;
          }
          const newStatus = this.deleteCount > 0 ? 'Pendiente' : 'No Cumplido';
          const itemChange = {
            companies_id: this.companyID,
            item_id: 49,
            status: newStatus,
          };
          newScoresAPI.calculateScores(itemChange)
            .then((response) => {
              setTimeout(() => {
                Swal.fire({
                  title: "¡Éxito!",
                  text: "¡Informacion eliminada con éxito!",
                  type: "success",
                  icon: "success",
                  confirmButtonClass: "btn btn-confirm mt-2",
                });
                window.location.reload();
              }, 2000);
            })
            .catch((error) => {
              this.loading = false
              setTimeout(() => {
                Swal.fire({
                  title: "Error",
                  text: "¡No se ha podido registrar!",
                  icon: "error",
                  type: "error",
                  confirmButtonClass: "btn btn-confirm mt-2",
                });
                window.location.reload();
              }, 1000);
              console.log(error);
            });
        })
        .catch((error) => {
          console.log(error);
        });
    },

    goBack() {
      this.$router.go(-1);
    },

    gotoDigitalOcean(url) {
      window.open(url);
    },

  },

  mounted() {
    this.getItems()
    this.getList();
    this.getItemData();
    // El catálogo primero: la alerta usa la ventana de preaviso (alertDays) que trae.
    this.getCatalogs().then(() => this.checkMaintenanceAlerts());
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row animated animatedFadeInUp fadeInUp">
      <div class="col-md-12">
        <div class="col-xl-12" v-if="!loading">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-md-6 col-sm-12">

                  <CheckModal>
                    <p class="text-justify">
                      Registrar la evidencia del mantenimiento preventivo y/o correctivo en las instalaciones, equipos,
                      máquinas y herramientas de acuerdo con los manuales de uso de estos y los informes de las visitas
                      de
                      inspección o reportes de condiciones inseguras.
                    </p>
                  </CheckModal>
                </div>

                <div class="form-row col-md-6 col-sm-12 pt-1">
                  <b-form-group id="statusInput" label-for="statusInput" class="col-sm-12" label="Estado del ítem">
                    <b-form-select v-on:change="changeItemStatus(itemStatus)"
                      :disabled="!getRole('Actualizar items', [1, 2, 3]) || !item || !allowAccess()" plain
                      class="selectpicker form-control" v-model="itemStatus">
                      <b-form-select-option value="Aprobado">Aprobado</b-form-select-option>
                      <b-form-select-option value="Pendiente">Pendiente</b-form-select-option>
                      <b-form-select-option value="No cumplido">No cumplido</b-form-select-option>
                    </b-form-select>
                  </b-form-group>
                </div>
              </div>

              <form class="form-group" @submit.prevent="save">
                <div class="form-row pt-3">

                  <b-form-group class="col-md-6" label="Código" label-for="employee">
                    <b-form-input type="text" id="code" v-model="inventory.code" placeholder=""></b-form-input>
                  </b-form-group>

                  <b-form-group class="col-md-6" label="Nombre (Instalación, equipo, maquinaria, herramienta)"
                    label-for="employee">
                    <b-form-input type="text" id="name" maxlength="60" v-model="inventory.name"
                      placeholder=""></b-form-input>
                  </b-form-group>

                </div>

                <div class="form-row">

                  <b-form-group class="col-md-3" label="Marca" label-for="input-sm">
                    <b-form-input type="text" id="brand" maxlength="50" v-model="inventory.brand" placeholder="">
                    </b-form-input>
                  </b-form-group>
                  <b-form-group class="col-md-3" label="Modelo" label-for="hora">
                    <b-form-input type="text" id="model" maxlength="50" v-model="inventory.model"
                      placeholder=""></b-form-input>
                  </b-form-group>
                  <!-- Periodicidad: base del cálculo del próximo mantenimiento y del semáforo. -->
                  <b-form-group class="col-md-3" label="Periodicidad de mantenimiento"
                    label-for="maintenanceFrequency">
                    <select id="maintenanceFrequency" class="form-control"
                      v-model="inventory.maintenance_frequency_months">
                      <option :value="null">Seleccione...</option>
                      <option v-for="(label, months) in frequencies" :key="months" :value="Number(months)">
                        {{ label }}
                      </option>
                    </select>
                    <small class="text-muted">Define cada cuánto vence el mantenimiento del activo.</small>
                  </b-form-group>
                  <b-form-group class="col-md-3" label="Estado" label-for="employee">
                    <select id="employeeID" class="form-control" v-model="inventory.status">
                      <b-form-select-option value="1">
                        Activo
                      </b-form-select-option>
                      <b-form-select-option value="0">
                        Inactivo
                      </b-form-select-option>
                    </select>
                  </b-form-group>
                </div>

                <div class="form-row">
                  <b-form-group class="col-md-12" label="Observaciones" label-for="input-sm">
                    <b-form-textarea id="description" maxlength="200" v-model="inventory.description"
                      rows="4"></b-form-textarea>
                  </b-form-group>

                </div>

                <div class="form-group text-right m-b-0">
                  <button :disabled="submitted" type="submit" class="btn btn-primary">
                    Guardar
                  </button>
                  <button type="button" class="btn btn-secondary mx-1" @click="goBack">
                    Cancelar
                  </button>
                </div>

                <hr v-if="getRole('Consultar')" />

                <div class="row" v-if="getRole('Consultar') || !allowAccess()">
                  <div class="col-lg-12">
                    <div class="card-body">
                      <div class="row pb-3">
                        <div class="col-6">
                          <form class="form-inline">
                            <div class="form-group mr-2">
                              <label for="productssearch-input" class="sr-only">Buscar</label>
                              <input type="search" :disabled="!allowAccess()" class="form-control border-light"
                                id="productssearch-input" placeholder="Buscar..." />
                            </div>
                            <button :disabled="!allowAccess()" type="button" class="btn btn-primary mb-2 mb-sm-0">
                              Buscar
                            </button>

                          </form>
                        </div>
                        <div class="col-6 text-right">
                          <!-- Reporte 4.2.5: activo + semáforo de cumplimiento de mantenimientos. -->
                          <button type="button" class="btn btn-success mb-2 mb-sm-0"
                            :disabled="!allowAccess() || downloading" @click="downloadComplianceReport">
                            <i class="mdi mdi-file-excel mr-1"></i>
                            {{ downloading ? "Generando..." : "Descargar reporte de cumplimiento (Excel)" }}
                          </button>
                        </div>
                      </div>

                      <div class="table-responsive">
                        <table class="pt-2 table border-bottom divide-y divide-gray-200 table-striped rounded">
                          <thead>
                            <tr>
                              <th class="text-center align-middle">Código</th>
                              <th class="text-center align-middle">Nombre</th>
                              <th class="text-center align-middle">Marca</th>
                              <th class="text-center align-middle">Modelo</th>
                              <th class="text-center align-middle">Periodicidad</th>
                              <th class="text-center align-middle">Último mantenimiento</th>
                              <th class="text-center align-middle">Próximo mantenimiento</th>
                              <th class="text-center align-middle">Cumplimiento</th>
                              <th class="text-center align-middle">Estado</th>
                              <th class="text-center align-middle">Acciones</th>
                            </tr>
                          </thead>
                          <tbody class="bg-white divide-y divide-gray-200">
                            <tr v-for="dato in lista" :key="dato.id">
                              <td class="text-center align-middle">
                                {{ dato.code }}
                              </td>
                              <td class="text-center align-middle">
                                {{ dato.name }}
                              </td>
                              <td class="text-center align-middle">
                                {{ dato.brand }}
                              </td>
                              <td class="text-center align-middle">
                                {{ dato.model }}
                              </td>

                              <td class="text-center align-middle">
                                {{ dato.maintenance_frequency_label || "Sin definir" }}
                              </td>

                              <td class="text-center align-middle">
                                {{ dato.last_maintenance ? dateConvert(dato.last_maintenance) : "Sin registro" }}
                              </td>

                              <td class="text-center align-middle">
                                {{ nextDueLabel(dato) }}
                              </td>

                              <!-- Semáforo: mismo estado y color que la celda del reporte Excel. -->
                              <td class="text-center align-middle">
                                <span class="badge badge-pill text-white px-2 py-1"
                                  :style="{ backgroundColor: dato.compliance_hex }">
                                  {{ dato.compliance_label }}
                                </span>
                              </td>

                              <td class="text-center align-middle">
                                <div v-if="dato.status === 1">
                                  <h6>Activo</h6>
                                </div>
                                <div v-else="dato.status== 0">
                                  <h6>Inactivo</h6>
                                </div>

                              </td>

                              <td class="text-center align-middle">
                                <div class="col-sm-12">
                                  <b-dropdown :disabled="!allowAccess()" variant="primary">
                                    <template v-slot:button-content>
                                      <i class="mdi mdi-eye"></i>
                                    </template>
                                    <b-dropdown-item :disabled="!getRole('Editar') || !allowAccess()"
                                      :to="{ path: `/forms/estandares/administracion-equipos-editar/${dato.id}` }">Editar</b-dropdown-item>
                                    <b-dropdown-item :disabled="!getRole('Editar') || !allowAccess()"
                                      :to="{ path: `/forms/estandares/mantenimiento-periodico/${dato.id}` }">Mantenimiento</b-dropdown-item>
                                    <b-dropdown-item @click="deleteR(dato.id)">Eliminar</b-dropdown-item>
                                  </b-dropdown>
                                </div>
                              </td>
                            </tr>


                          </tbody>
                        </table>
                        <div>
                          <Pagination ref="paginator" @fetch="(items) => (lista = items)" />
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- end col -->
                </div>
              </form>
            </div>
          </div>

        </div>

        <div v-else class="col-xl-12 text-center">
          <div class="text-center">
            <b-spinner variant="primary" label="Loading..."></b-spinner>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style scoped>
.background-modal {
  background-color: transparent !important;
  border: none;
}
</style>